export const HTTP_METHOD_GET = 1
export const HTTP_METHOD_POST = 2
